/**
 * --------------------------------------------
 * Treeview.js
 * --------------------------------------------
 */
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
};

var Treeview = function($) {
    /**
     * Constants
     * ====================================================
     */

    var NAME = 'Treeview';
    var DATA_KEY = 'lte.treeview';
    var EVENT_KEY = '.' + DATA_KEY;
    var JQUERY_NO_CONFLICT = $.fn[NAME];

    var Event = {
        SELECTED: 'selected' + EVENT_KEY,
        EXPANDED: 'expanded' + EVENT_KEY,
        COLLAPSED: 'collapsed' + EVENT_KEY,
        LOAD_DATA_API: 'load' + EVENT_KEY
    };

    var Selector = {
        LI: '.nav-item',
        LINK: '.nav-link',
        TREEVIEW_MENU: '.nav-treeview',
        OPEN: '.menu-open',
        DATA_WIDGET: '[data-widget="treeview"]'
    };

    var ClassName = {
        LI: 'nav-item',
        LINK: 'nav-link',
        TREEVIEW_MENU: 'nav-treeview',
        OPEN: 'menu-open'
    };

    var Default = {
        trigger: Selector.DATA_WIDGET + ' ' + Selector.LINK,
        animationSpeed: 300,
        accordion: true

        /**
         * Class Definition
         * ====================================================
         */
    };
    var classCallCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    };

    var Treeview = function() {
        function Treeview(element, config) {
            classCallCheck(this, Treeview);

            this._config = config;
            this._element = element;
        }

        // Public

        Treeview.prototype.init = function init() {
            this._setupListeners();
        };

        Treeview.prototype.expand = function expand(treeviewMenu, parentLi) {
            var _this = this;

            var expandedEvent = $.Event(Event.EXPANDED);

            if (this._config.accordion) {
                var openMenuLi = parentLi.siblings(Selector.OPEN).first();
                var openTreeview = openMenuLi.find(Selector.TREEVIEW_MENU).first();
                this.collapse(openTreeview, openMenuLi);
            }

            treeviewMenu.slideDown(this._config.animationSpeed, function() {
                parentLi.addClass(ClassName.OPEN);
                $(_this._element).trigger(expandedEvent);
            });
        };

        Treeview.prototype.collapse = function collapse(treeviewMenu, parentLi) {
            var _this2 = this;

            var collapsedEvent = $.Event(Event.COLLAPSED);

            treeviewMenu.slideUp(this._config.animationSpeed, function() {
                parentLi.removeClass(ClassName.OPEN);
                $(_this2._element).trigger(collapsedEvent);
                treeviewMenu.find(Selector.OPEN + ' > ' + Selector.TREEVIEW_MENU).slideUp();
                treeviewMenu.find(Selector.OPEN).removeClass(ClassName.OPEN);
            });
        };

        Treeview.prototype.toggle = function toggle(event) {
            var $relativeTarget = $(event.currentTarget);
            var treeviewMenu = $relativeTarget.next();

            if (!treeviewMenu.is(Selector.TREEVIEW_MENU)) {
                return;
            }

            event.preventDefault();

            var parentLi = $relativeTarget.parents(Selector.LI).first();
            var isOpen = parentLi.hasClass(ClassName.OPEN);

            if (isOpen) {
                this.collapse($(treeviewMenu), parentLi);
            } else {
                this.expand($(treeviewMenu), parentLi);
            }
        };

        // Private
        Treeview.prototype._setupListeners = function _setupListeners() {
            var _this3 = this;
            $(document).on('click', this._config.trigger, function(event) {
                //event.preventDefault();
                _this3.toggle(event);
            });
        };

        // Static

        Treeview._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $(this).data(DATA_KEY);
                var _config = $.extend({}, Default, $(this).data());

                if (!data) {
                    data = new Treeview($(this), _config);
                    $(this).data(DATA_KEY, data);
                }

                if (config === 'init') {
                    data[config]();
                }
            });
        };

        return Treeview;
    }();

    /**
     * Data API
     * ====================================================
     */

    $(window).on(Event.LOAD_DATA_API, function() {
        $(Selector.DATA_WIDGET).each(function() {
            Treeview._jQueryInterface.call($(this), 'init');
        });
    });

    /**
     * jQuery API
     * ====================================================
     */

    $.fn[NAME] = Treeview._jQueryInterface;
    $.fn[NAME].Constructor = Treeview;
    $.fn[NAME].noConflict = function() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Treeview._jQueryInterface;
    };

    return Treeview;
}(jQuery);

var PushMenu = function($) {
    /**
     * Constants
     * ====================================================
     */

    var NAME = 'PushMenu';
    var DATA_KEY = 'lte.pushmenu';
    var EVENT_KEY = '.' + DATA_KEY;
    var JQUERY_NO_CONFLICT = $.fn[NAME];

    var Event = {
        COLLAPSED: 'collapsed' + EVENT_KEY,
        SHOWN: 'shown' + EVENT_KEY
    };

    var Default = {
        screenCollapseSize: 768
    };

    var Selector = {
        TOGGLE_BUTTON: '[data-widget="pushmenu"]',
        SIDEBAR_MINI: '.sidebar-mini',
        SIDEBAR_COLLAPSED: '.sidebar-collapse',
        BODY: 'body',
        OVERLAY: '#sidebar-overlay',
        WRAPPER: '.wrapper'
    };

    var ClassName = {
        SIDEBAR_OPEN: 'sidebar-open',
        COLLAPSED: 'sidebar-collapse',
        OPEN: 'sidebar-open',
        SIDEBAR_MINI: 'sidebar-mini'

        /**
         * Class Definition
         * ====================================================
         */

    };
    var PushMenu = function() {
        function PushMenu(element, options) {
            classCallCheck(this, PushMenu);

            this._element = element;
            this._options = $.extend({}, Default, options);

            if (!$(Selector.OVERLAY).length) {
                this._addOverlay();
            }
        }

        // Public

        PushMenu.prototype.show = function show() {
            $(Selector.BODY).addClass(ClassName.OPEN).removeClass(ClassName.COLLAPSED);

            var shownEvent = $.Event(Event.SHOWN);
            $(this._element).trigger(shownEvent);
        };

        PushMenu.prototype.collapse = function collapse() {
            $(Selector.BODY).removeClass(ClassName.OPEN).addClass(ClassName.COLLAPSED);

            var collapsedEvent = $.Event(Event.COLLAPSED);
            $(this._element).trigger(collapsedEvent);
        };

        PushMenu.prototype.toggle = function toggle() {
            var isShown = void 0;
            if ($(window).width() >= this._options.screenCollapseSize) {
                isShown = !$(Selector.BODY).hasClass(ClassName.COLLAPSED);
            } else {
                isShown = $(Selector.BODY).hasClass(ClassName.OPEN);
            }

            if (isShown) {
                this.collapse();
            } else {
                this.show();
            }
        };

        // Private


        PushMenu.prototype._addOverlay = function _addOverlay() {
            var _this = this;

            var overlay = $('<div />', {
                id: 'sidebar-overlay'
            });

            overlay.on('click', function() {
                _this.collapse();
            });

            $(Selector.WRAPPER).append(overlay);
        };

        // Static

        PushMenu._jQueryInterface = function _jQueryInterface(operation) {
            return this.each(function() {
                var data = $(this).data(DATA_KEY);

                if (!data) {
                    data = new PushMenu(this);
                    $(this).data(DATA_KEY, data);
                }

                if (operation) {
                    data[operation]();
                }
            });
        };

        return PushMenu;
    }();

    //custom menu scrollbar

    $(window).on("load", function() {
        if ($("#sidebar").length > 0) {
            $.mCustomScrollbar.defaults.scrollButtons.enable = true;
            $.mCustomScrollbar.defaults.axis = "yx";
            $("#sidebar").mCustomScrollbar({
                axis: "y",

                theme: "my-theme"
            });
        }
    });


    /**
     * Data API
     * ====================================================
     */

    $(document).on('click', Selector.TOGGLE_BUTTON, function(event) {
        event.preventDefault();

        var button = event.currentTarget;

        if ($(button).data('widget') !== 'pushmenu') {
            button = $(button).closest(Selector.TOGGLE_BUTTON);
        }

        PushMenu._jQueryInterface.call($(button), 'toggle');
    });

    /**
     * jQuery API
     * ====================================================
     */

    $.fn[NAME] = PushMenu._jQueryInterface;
    $.fn[NAME].Constructor = PushMenu;
    $.fn[NAME].noConflict = function() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return PushMenu._jQueryInterface;
    };

    return PushMenu;
}(jQuery);
